module.exports = __webpack_public_path__ + "img/schedule_sp.dea5a5ed.svg";